import React, { useEffect, useState } from "react";
import { Image, Keyboard, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../Separator";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { CommonButton } from "../../common/CommonButton";
import CommonTextInputWeb from "../../common/CommonTextInputWeb";
import { AppImages } from "../../utility/AppImages";
import { toast } from "react-toastify";
import { blockUser } from "../../services/authAPI";
import { handleApiError } from "../../services/errorHandler";
import AccountTabSkeleton from "../skeleton-components/AccountTabSkeleton";
import { useUserProfile } from "../../hooks/useUserProfile";

const DeactivateTabComponent = ({ accessToken, getLoginUserData }) => {
  const { userProfileData, loading: profileLoading } = useUserProfile(accessToken);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [activeTab, setActiveTab] = useState("deactivate");
  const [reason, setReason] = useState("");

  const [deactivaePassphrase, setDeactivatePassphrase] = useState("");
  const [deletePassphrase, setDeletePassphrase] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setReason("");
    setDeactivatePassphrase("");
    setDeletePassphrase("");
    setPassword("");
  }, [activeTab]);

  if (profileLoading) {
    return <AccountTabSkeleton />;
  }

  const callBlockUserApi = async (type) => {
    if (!reason.trim()) {
      toast.error("Please provide a reason");
      return;
    }

    const bodyParams = {
      username: userProfileData.userID,
      password,
      type,
      reason,
    };

    try {
      setShowLoader(true);
      const response = await blockUser(bodyParams);

      if (response?.statusCode === 200 || response?.statusCode === 201) {
        toast.success(
          response.body?.message || "Action completed successfully"
        );
        await getLoginUserData();
      } else if (response?.statusCode === 400) {
        toast.error(
          response.body?.error || "Bad request. Please check your inputs."
        );
      } else if (response?.statusCode === 401) {
        toast.error(
          response.body?.error || "Unauthorized. Please check your credentials."
        );
      } else if (response?.statusCode === 404) {
        toast.error(response.body?.error || "User not found.");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong. Please try again.");
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <View
      style={{
        backgroundColor: AppColors.purple_453B50,
        borderRadius: 10,
        paddingTop: 20,
        paddingBottom: 30,
        // width:
        //   deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
        //     ? "100%"
        //     : 866,
        width: "100%",
      }}
    >
      <View style={styles.tabContainer}>
        <TouchableOpacity
          style={[styles.tabButton]}
          onPress={() => setActiveTab("deactivate")}
        >
          <View
            style={{
              paddingTop:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 10,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_12
                  : AppFontStyle.BOLD_ANYBODY_20,
                {
                  color:
                    activeTab === "deactivate"
                      ? AppColors.red_FA0A0A
                      : AppColors.white,
                },
              ]}
            >
              Deactivate Account
            </Text>
            {activeTab === "deactivate" && (
              <Separator
                color={AppColors.green_4CD964}
                height={2}
                marginTop={5}
                marginBottom={0}
                width={"40"}
                marginHorizontal={0}
              />
            )}
          </View>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.tabButton]}
          onPress={() => setActiveTab("delete")}
        >
          <View
            style={{
              paddingTop:
                deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
                  ? 0
                  : 10,
            }}
          >
            <Text
              style={[
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? AppFontStyle.BOLD_ANYBODY_12
                  : AppFontStyle.BOLD_ANYBODY_20,
                {
                  color:
                    activeTab === "delete"
                      ? AppColors.red_FA0A0A
                      : AppColors.white,
                },
              ]}
            >
              Delete Account
            </Text>
            {activeTab === "delete" && (
              <Separator
                color={AppColors.green_4CD964}
                height={2}
                marginTop={5}
                marginBottom={0}
                width={"40"}
                marginHorizontal={0}
              />
            )}
          </View>
        </TouchableOpacity>
      </View>
      <View style={{ marginHorizontal: 20 }}>
        {activeTab === "deactivate" && (
          <View>
            <View
              style={{
                backgroundColor: AppColors.lightPurple_604e74,
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                    ? "100%"
                    : 568,
                marginTop: 30,
                marginBottom: 50,
                //@ts-ignore
                boxShadow: `0px -4px 4px 0px ${AppColors.red_A23143}`,
                borderRadius: 10,
                padding: 20,
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ justifyContent: "center" }}>
                <TouchableOpacity onPress={() => {}} style={{}}>
                  <Image
                    source={AppImages.icShield}
                    style={{
                      borderColor: AppColors.red_912121,
                      width: 81,
                      height: 81,
                    }}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS
                      ? 200
                      : deviceSize === DEVICE_SIZES.SM
                      ? 340
                      : deviceSize === DEVICE_SIZES.MD ||
                        deviceSize === DEVICE_SIZES.LG
                      ? 466
                      : 411,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_18,
                    {
                      paddingBottom:
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? 10
                          : 20,
                    },
                  ]}
                >
                  This is extremely important
                </Text>

                <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                  Deactivating your account will temporarily disable your
                  profile. You can reactivate it anytime by logging back in.
                </Text>
              </View>
            </View>
            <View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Reason for Deactivation
                </Text>
                <CommonTextInputWeb
                  placeholder="Reason for deactivation"
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  isPassword={false}
                  value={reason}
                  onChangeText={(text: string) => setReason(text)}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Username
                </Text>
                <CommonTextInputWeb
                  placeholder={userProfileData.userID}
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={() => {}}
                  isPassword={false}
                  value={userProfileData.userID}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  editable={false}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Password
                </Text>
                <CommonTextInputWeb
                  placeholder="Enter Password"
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={setPassword}
                  isPassword={true}
                  value={password}
                  secureTextEntry={showPassword ? false : true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  isRequired={false}
                  onPressEyeIcon={() => {
                    setShowPassword(!showPassword);
                  }}
                  rightIcon={
                    showPassword ? AppImages.icEye : AppImages.icEyeClose
                  }
                  showEyeIcon={true}
                  rightIconStyle={{ width: 20, height: 20, marginRight: 10 }}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Passphrase
                </Text>
                <CommonTextInputWeb
                  placeholder=""
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={(text: string) => setDeactivatePassphrase(text)}
                  isPassword={false}
                  value={deactivaePassphrase}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                />
              </View>
            </View>
            <View style={styles.accountData}>
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
              ></Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_A3A3A3 },
                ]}
              >
                To verify type:{" "}
                <Text
                  style={{
                    color: AppColors.white,
                  }}
                >
                  Please deactivate my account
                </Text>
              </Text>
            </View>
            <View style={styles.accountData}>
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
              ></Text>
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "100%"
                      : 284,
                  alignItems: "flex-end",
                }}
              >
                <CommonButton
                  title={showLoader ? "Processing..." : "Save"}
                  textStyle={AppFontStyle.BOLD_ANYBODY_12}
                  onTap={async () => {
                    if (showLoader) return;
                    const type = "deactive";
                    deactivaePassphrase === "Please deactivate my account"
                      ? await callBlockUserApi(type)
                      : toast.info(
                          "Type 'Please deactivate my account' to proceed."
                        );
                  }}
                  buttonStyle={{
                    paddingVertical: 14,
                    backgroundColor: showLoader ? AppColors.gray_5C5C5C : AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    shadowOpacity: 0,
                    width: 120,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 4 },
                    shadowRadius: 4,
                    elevation: 4,
                    marginTop: 30,
                    opacity: showLoader ? 0.7 : 1,
                  }}
                  disabled={showLoader}
                />
              </View>
            </View>
          </View>
        )}

        {activeTab === "delete" && (
          <View>
            <View
              style={{
                backgroundColor: AppColors.lightPurple_604e74,
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                    ? "100%"
                    : 568,
                marginTop: 30,
                marginBottom: 50,
                //@ts-ignore
                boxShadow: `0px -4px 4px 0px ${AppColors.red_A23143}`,
                borderRadius: 10,
                padding: 20,
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <View style={{ justifyContent: "center" }}>
                <TouchableOpacity onPress={() => {}} style={{}}>
                  <Image
                    source={AppImages.icShield}
                    style={{
                      borderColor: AppColors.red_912121,
                      width: 81,
                      height: 81,
                    }}
                  />
                </TouchableOpacity>
              </View>
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.XS
                      ? 200
                      : deviceSize === DEVICE_SIZES.SM
                      ? 340
                      : deviceSize === DEVICE_SIZES.MD ||
                        deviceSize === DEVICE_SIZES.LG
                      ? 466
                      : 411,
                }}
              >
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_18,
                    {
                      paddingBottom:
                        deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                          ? 10
                          : 20,
                    },
                  ]}
                >
                  This is extremely important
                </Text>

                <Text style={[AppFontStyle.REGULAR_ANYBODY_14, {}]}>
                  This is a permanent action. All related events, tournaments,
                  and organisations within this account will be removed. Your
                  username will then become available for anyone on ESQUADIFI to
                  use.
                </Text>
              </View>
            </View>
            <View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Reason for Deleting Account
                </Text>
                <CommonTextInputWeb
                  placeholder="Reason for deletion"
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={(text: string) => setReason(text)}
                  isPassword={false}
                  value={reason}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Username
                </Text>
                <CommonTextInputWeb
                  placeholder={userProfileData.userID}
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={() => {}}
                  isPassword={false}
                  value={userProfileData.userID}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  editable={false}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Password
                </Text>
                <CommonTextInputWeb
                  placeholder="Enter Password"
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={setPassword}
                  isPassword={true}
                  value={password}
                  secureTextEntry={showPassword ? false : true}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                  isRequired={false}
                  onPressEyeIcon={() => {
                    setShowPassword(!showPassword);
                  }}
                  rightIcon={
                    showPassword ? AppImages.icEye : AppImages.icEyeClose
                  }
                  showEyeIcon={true}
                  rightIconStyle={{ width: 20, height: 20, marginRight: 10 }}
                />
              </View>
              <View style={styles.accountData}>
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
                >
                  Passphrase
                </Text>
                <CommonTextInputWeb
                  placeholder=""
                  mainStyle={[styles.accountInputStyle]}
                  inputStyle={[AppFontStyle.REGULAR_ANYBODY_14]}
                  prefixIconVisibility={false}
                  onChangeText={(text: string) => setDeletePassphrase(text)}
                  isPassword={false}
                  value={deletePassphrase}
                  onSubmitEditing={() => {
                    Keyboard.dismiss();
                  }}
                  autoCapitalize="none"
                  maxLength={50}
                />
              </View>
            </View>
            <View style={styles.accountData}>
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
              ></Text>
              <Text
                style={[
                  AppFontStyle.REGULAR_ANYBODY_12,
                  { color: AppColors.gray_A3A3A3 },
                ]}
              >
                To verify type:{" "}
                <Text
                  style={{
                    color: AppColors.white,
                  }}
                >
                  Please delete my account
                </Text>
              </Text>
            </View>
            <View style={styles.accountData}>
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_14, styles.accountText]}
              ></Text>
              <View
                style={{
                  width:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "100%"
                      : 284,
                  alignItems: "flex-end",
                }}
              >
                <CommonButton
                  title={showLoader ? "Processing..." : "Save"}
                  textStyle={AppFontStyle.BOLD_ANYBODY_12}
                  onTap={async () => {
                    if (showLoader) return;
                    const type = "delete";
                    deletePassphrase === "Please delete my account"
                      ? await callBlockUserApi(type)
                      : toast.info(
                          "Type 'Please delete my account' to proceed."
                        );
                  }}
                  buttonStyle={{
                    paddingVertical: 14,
                    backgroundColor: showLoader ? AppColors.gray_5C5C5C : AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    shadowOpacity: 0,
                    width: 120,
                    shadowColor: "#000",
                    shadowOffset: { width: 0, height: 4 },
                    shadowRadius: 4,
                    elevation: 4,
                    marginTop: 30,
                    opacity: showLoader ? 0.7 : 1,
                  }}
                  disabled={showLoader}
                />
              </View>
            </View>
          </View>
        )}
      </View>
    </View>
  );
};

export default DeactivateTabComponent;

const useStyles = CreateResponsiveStyle(
  {
    accountData: {
      flexDirection: "row",
      gap: 20,
      alignItems: "center",
      marginBottom: 20,
    },
    accountText: {
      width: 99,
      textAlign: "right",
    },
    accountInputStyle: {
      backgroundColor: AppColors.black,
      borderRadius: 10,
      width: 284,
      height: 40,
    },

    tabContainer: {
      flexDirection: "row",
      justifyContent: "flex-start",
      marginBottom: 20,
    },
    tabButton: {
      paddingVertical: 10,
      paddingHorizontal: 20,
      borderBottomWidth: 2,
      borderColor: "transparent",
    },

    tabText: {
      color: "white",
      fontSize: 16,
    },

    title: {
      fontSize: 20,
      color: "white",
      marginBottom: 10,
    },
    infoText: {
      color: "white",
      marginBottom: 15,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      tabButton: {
        paddingHorizontal: 10,
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
    },
    [DEVICE_SIZES.XS]: {
      accountInputStyle: {
        flex: 1,
        width: "100%",
      },
      tabButton: {
        paddingHorizontal: 10,
      },
      accountData: {
        flexDirection: "column",
        gap: 10,
      },
      accountText: {
        width: "100%",
        textAlign: "left",
      },
    },
  }
);
